module.exports = __webpack_public_path__ + "static/media/Employer_2.ad01e576.svg";